import {Outlet} from 'react-router-dom';
import {ArrivalProvider} from 'src/context/ArrivalContext';
import {useCssWorkarounds} from 'src/hooks/useCssWorkarounds';

export function ArrivalRoot() {
    useCssWorkarounds();

    return (
        <ArrivalProvider>
            <Outlet />
        </ArrivalProvider>
    );
}
